export default __webpack_public_path__ + "static/media/featured.43c05be1.png";